import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import MyProfileLayer from "../components/MyProfileLayer";


const MyProfile = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="My Profile" />

        {/* MyProfileLayer */}
        <MyProfileLayer />


      </MasterLayout>
    </>
  );
};

export default MyProfile;
